import React from 'react'
import ProductsSectionTitle from '../ProductsSectionTitle';
import { Element } from 'react-scroll';

const WhatIsAgenticAI = () => {
  return (
    <>
      <Element
        name="WhatIsAgenticAI"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <ProductsSectionTitle
                classes = "text-center"
                title = "What is Agentic AI?"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <div className="aaai-content">
                <p>Agentic AI refers to autonomous intelligent agents—purpose-built, task-focused, and able to continuously sense, reason, and act in dynamic environments. Unlike single models or scripts, agentic AI orchestrates tools, learns from feedback, and adapts to changing data in real time.</p>
                <ul>
                  <li><span className="color-primary"><strong>Autonomous:</strong></span> Agents make local decisions and execute actions, reducing the need for constant manual oversight.</li>
                  <li><span className="color-primary"><strong>Modular:</strong></span> Swap, configure, and extend agents to fit evolving business or regulatory needs.</li>
                  <li><span className="color-primary"><strong>Edge & Cloud Native:</strong></span> Deploy agents on MEA hardware, other edge devices, or integrate with cloud platforms—hybrid workflows are seamless.</li>
                  <li><span className="color-primary"><strong>Configurable:</strong></span> Customize behaviors, alerts, and integrations via simple config files (YAML/JSON).</li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default WhatIsAgenticAI;